<template>
  <div class="_rfp_mctb_list_10_ rfp-mctb-product-list-row">
    <div class="_rfp_mctb_list_14_ rfp-mctb-error" v-html="errorMessage"></div>
  </div>
</template>
<script>
export default {
  name: 'rfp-mctb-error',
  props: {
    errorMessage: {
      type: String,
      required: false,
    },
  },
};
</script>
<style scoped>
.rfp-mctb-error {
  font-size: 19px;
  color: red;
}
</style>
